/**
 * Created by pablo on 8/22/17.
 */

(function ($, undefined) {
    'use strict';

    const button = document.querySelector('i.fa-copy');
    const input = document.querySelector('#tango_url_clipboard');
    const message = document.querySelector('#message');

    button.addEventListener('click',function () {
        input.select();
        document.execCommand("copy");
        message.innerHTML = "Copiado al portapapeles";
        setTimeout(()=> message.innerHTML = "", 2500);
    })

    //binding

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/tango.integrate.js